// src/pages/TrustPage.jsx
import React from "react";

const SUPPORT_EMAIL = "support@starepochlabs.com";

export default function TrustPage() {
  return (
    <div className="space-y-10">
      <section className="rounded-3xl border border-white/10 bg-white/5 p-10">
        <p className="text-sm font-semibold text-cyan-300/90">Trust Center</p>
        <h2 className="mt-3 text-3xl font-semibold tracking-tight text-white">Security, privacy, and transparency</h2>
        <p className="mt-4 max-w-3xl text-base leading-7 text-white/75 mx-auto">
          Trust is earned through clear practices and consistent engineering. This page summarizes our approach to
          data minimization, security, and responsible communication.
        </p>

        <div className="mt-8 grid gap-6 md:grid-cols-2">
          <div className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <div className="text-sm font-semibold">Data minimization</div>
            <ul className="mt-3 space-y-2 text-sm text-white/70">
              <li>• We aim to collect only what is necessary to operate and support the service.</li>
              <li>• We do not sell personal data.</li>
              <li>• We do not use your traffic contents for advertising.</li>
            </ul>
            <div className="mt-4 text-sm text-white/70">
              Details are described in our <a className="text-cyan-300 hover:underline" href="/privacy">Privacy Policy</a>.
            </div>
          </div>

          <div className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <div className="text-sm font-semibold">Security by design</div>
            <ul className="mt-3 space-y-2 text-sm text-white/70">
              <li>• Encryption-first approach for data in transit where applicable.</li>
              <li>• Least-privilege access and ongoing reliability improvements.</li>
              <li>• Monitoring and rapid incident response workflows.</li>
            </ul>
            <div className="mt-4 text-sm text-white/70">
              If you believe you found a security issue, contact:{" "}
              <a className="text-white hover:underline" href={`mailto:${SUPPORT_EMAIL}`}>
                {SUPPORT_EMAIL}
              </a>
            </div>
          </div>

          <div className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <div className="text-sm font-semibold">Transparency</div>
            <div className="mt-3 text-sm text-white/70">
              We strive to communicate our practices clearly, including what we do and do not collect, and how users
              can reach us for support and privacy requests.
            </div>
          </div>

          <div className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <div className="text-sm font-semibold">Support accountability</div>
            <div className="mt-3 text-sm text-white/70">
              We provide a public support channel and a clear policy footprint (Privacy/Terms). This improves user
              clarity and helps maintain long-term service quality.
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
